import React, { useMemo } from "react";
import { Select } from "kubra-ux-forge";
import { useField } from "formik";

interface SelectManyProps {
  name: string;
  label: string;
  placeholder?: string;
  options: string[];
  editableIfPrefilled?: boolean;
}

export const SelectManyField: React.FC<SelectManyProps> = ({
  name,
  options,
  label,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta, helpers] = useField(name);

  let disabled = false;

  if (
    meta.initialValue &&
    Array.isArray(meta.initialValue) &&
    meta.initialValue.length > 0 &&
    !editableIfPrefilled
  ) {
    disabled = true;
  }

  const selectedCount = field.value.length;
  let dynamicPlaceholder = placeholder;
  if (selectedCount === 1) {
    dynamicPlaceholder = "1 Selected";
  } else if (selectedCount > 1) {
    dynamicPlaceholder = `${selectedCount} Selected`;
  }

  const handleSelectChange = (selectedOptions: any) => {
    const selectedValues = selectedOptions.map((option: any) => option.name);
    helpers.setValue(selectedValues);
  };

  const selectOptions = useMemo(
    () => options.map((opt) => ({ name: opt })),
    [options]
  );

  return (
    <div className="select-field-container">
      <Select
        {...field}
        label={label}
        defaultValue={meta.initialValue}
        onChange={handleSelectChange}
        options={selectOptions}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        dataCy={name}
        placeholder={dynamicPlaceholder}
        disabled={disabled}
        isMultiSelect
        isFilterable
      />
    </div>
  );
};
